import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { FooterComponent } from './footer/footer.component';
import { BasicLayoutComponent } from './layouts/basicLayout.component';
import { BlankLayoutComponent } from './layouts/blankLayout.component';
import { NavigationComponent } from './navigation/navigation.component';
import { TopNavigationLayoutComponent } from './layouts/topNavigationLayout.component';
import { TopNavbarComponent } from './topnavbar/topnavbar.component';
import { TopNavigationNavbarComponent } from './topnavbar/topnavigationnavbar.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { AlteraSenhaComponent } from './altera-senha/altera-senha.component';
import { CommonModule } from '@angular/common';
import { LoginService } from '../shared/services/login.service';
import { SharedModule } from '../shared/shared.module';
import { RecoverPasswordComponent } from './recover-password/recover-password.component';
import { RecoverPasswordResolver } from '../shared/resolver/recover-password.resolver';
import { NgSelectModule } from '@ng-select/ng-select';
import { ChatBotComponent } from '../modules/chat-bot/components/chat-bot/chat-bot.component';


@NgModule({
  declarations: [
    FooterComponent,
    BasicLayoutComponent,
    BlankLayoutComponent,
    NavigationComponent,
    TopNavigationLayoutComponent,
    TopNavbarComponent,
    TopNavigationNavbarComponent,
    UnauthorizedComponent,
    AlteraSenhaComponent,
    RecoverPasswordComponent,
    ChatBotComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    RouterModule,
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
  ],
  exports: [
    FooterComponent,
    BasicLayoutComponent,
    BlankLayoutComponent,
    NavigationComponent,
    TopNavigationLayoutComponent,
    TopNavbarComponent,
    TopNavigationNavbarComponent,
    UnauthorizedComponent,
  ],
  providers: [
    LoginService,
    RecoverPasswordResolver,
  ]
})
export class CoreModule {}
